import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import ContentViewer from "../ContentsViewer/ContentViewer";
import FileViewer from "../ContentsViewer/FileViewer";
import ImageViewer from "../ContentsViewer/ImageViewer";
import QuestionnaireViewer from "../ContentsViewer/Questionnaire/QuestionnaireViewer";
import * as contentTypes from '../Editor/contentTypes';
import Navigator from "./Navigator/Navigator";
import classes from "./Player.module.css";
import arrow from '../assests/arrow-menu.svg'
import question from '../assests/question.png';
import learning from '../assests/learn.png'
import { mergeData, shouldAutoChangeContent } from "../ContentsViewer/utils";

const enumCMSContentTypeViewer = {
    file: FileViewer,
    tinyMCE: ContentViewer,
    quetion: QuestionnaireViewer,
    image: ImageViewer
}

const Player = ({
    contentDirPath = '',
    metaPath = 'meta.json',
    index = 0,
    close,
    lessonId,
    studyGroupId,
    submissions,
    postAnswer,
    setCurrentContentData,
    userId,
    onlyView,
    scoreByRetries,
    questionExtranelId,
    jumpToQuestion,
    setSumQuestions,
    currentContentData }) => {

    const ref = useRef();
    const { direction } = useSelector(state => state.translate);

    const [contentList, setContentList] = useState()
    const [sizes, setSizes] = useState({ viewerStyle: {}, wrapStyle: {} });
    const [currentContent, setCurrentContent] = useState();
    const [showMenu, setShowMenu] = useState(true);
    const [isOldDesign, setIsOldDesign] = useState(false);
    const [timeToResize, setTimeToResize] = useState(true);
    const [prevMetaDataJson, setPrevMetaDataJson] = useState(null);
    const [remindSendBtn, setRemindSendBtn] = useState(false);
    const [newQuestion, setNewQuestion] = useState()

    const calcSizes = (x) => {
        const metaDataJson = x || prevMetaDataJson;
        if (metaDataJson && ref.current) {
            let playerSize = ref.current.getBoundingClientRect();
            let menuWidth = metaDataJson.contents.reduce((longest, current) => {
                return current.name.length > longest ? current.name.length : longest;
            }, 0) * 10 + 90;
            menuWidth = showMenu ? (menuWidth < 200 ? menuWidth : 200) : 90;
            let width = playerSize.width - menuWidth;
            let height = width * metaDataJson.proportion;
            if (height > (playerSize.height - 47)) {
                height = playerSize.height - 47;
                width = height / metaDataJson.proportion;
            }
            let scale = width / metaDataJson.editorWidth;

            setSizes({
                wrapStyle: {
                    height: height,
                    width: width + menuWidth
                },
                viewerStyle: {
                    height: metaDataJson.editorHeight,
                    width: metaDataJson.editorWidth,
                    zoom: scale,
                    menuWidth: menuWidth
                }
            });
        }
    }

    useEffect(() => {
        (async () => {
            try {
                let notCacheNumber = Math.floor(new Date().getTime());
                const mataData = await fetch(`${contentDirPath}${metaPath}${contentDirPath ? `?notCacheNumber=${notCacheNumber}` : ''}`);
                if (mataData.ok) {
                    const metaDataJson = await mataData.json();
                    setContentList(metaDataJson.contents);
                    const oldDesign = !metaDataJson.version || metaDataJson.version < 2
                    setIsOldDesign(!metaDataJson.version || metaDataJson.version < 2)
                    setSumQuestions && setSumQuestions(metaDataJson.contents.filter(x => x.type == contentTypes.quetion).length)
                    if (questionExtranelId) {
                        let quetionIdex = metaDataJson.contents.findIndex(c => c.type === contentTypes.quetion && c.data?.quetions?.some(q => q.id === questionExtranelId))
                        if (quetionIdex != -1)
                            HandleChangeCurrentContent(metaDataJson.contents[quetionIdex], quetionIdex, oldDesign);
                        else
                            HandleChangeCurrentContent(metaDataJson.contents[index], index, oldDesign);
                    }
                    else {
                        if (jumpToQuestion) {
                            let jumpToQuestionIndex = metaDataJson.contents.findIndex(x => x.type == contentTypes.quetion)
                            if (jumpToQuestionIndex != -1)
                                HandleChangeCurrentContent(metaDataJson.contents[jumpToQuestionIndex], jumpToQuestionIndex, oldDesign)
                        }
                        else {
                            if (index === 0) {
                                try {
                                    let usersJson = localStorage.getItem("lmsPlayerCurreuntSlides");
                                    let saveIndex = 0;
                                    if (usersJson) {
                                        usersJson = JSON.parse(usersJson);
                                        if (userId && usersJson[userId] && usersJson[userId][lessonId]) {
                                            saveIndex = metaDataJson.contents.findIndex(x => x.id === usersJson[userId][lessonId].slideId);
                                            if (saveIndex === -1) {
                                                saveIndex = 0;

                                            }
                                        }
                                        try {
                                            Object.keys(usersJson).forEach(u => Object.keys(usersJson[u]).forEach(l => {
                                                if (Math.abs((new Date(usersJson[u][l].date) - new Date())) / (1000 * 60 * 60 * 24) > 14) {
                                                    delete usersJson[u][l]
                                                }
                                            }))
                                        } catch { }
                                    }
                                    HandleChangeCurrentContent(metaDataJson.contents[saveIndex], saveIndex, oldDesign);
                                }
                                catch {
                                    HandleChangeCurrentContent(metaDataJson.contents[index], index, oldDesign);
                                }
                            }
                            else {
                                HandleChangeCurrentContent(metaDataJson.contents[index], index, oldDesign);
                            }
                        }
                    }
                    calcSizes(metaDataJson)
                    setPrevMetaDataJson(metaDataJson)
                }
            }
            catch (e) {
                console.error(e)
            }
        })()
    }, [contentDirPath, metaPath])

    useEffect(() => {
        calcSizes();
    }, [timeToResize, showMenu])

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            setTimeToResize(prev => !prev)
        });

        if (ref?.current)
            observer.observe(ref.current);

        return () => {
            observer.disconnect();
        }
    }, [])

    useEffect(() => {
        if (currentContent)
            changeCurrentContent(currentContent.content, currentContent.index)
    }, [remindSendBtn])

    const HandleChangeCurrentContent = (content, index, oldDesign = isOldDesign, autoTransition = false) => {
        if (currentContent?.content.data.quetions?.find(q => q.changed) && !remindSendBtn && !autoTransition) {
            setRemindSendBtn(true)
            return;
        }
        content = {
            ...content,
            data: {
                ...content?.data,
                quetions: mergeData(contentList?.find(c=> c.id === content.id).data.quetions || content.data.quetions, submissions)
            }
        };
        setCurrentContentData && setCurrentContentData({ currentIndex: index, contentsLength: contentList?.length })
        changeCurrentContent(content, index, oldDesign)
        setRemindSendBtn(false)

        try {
            if (userId && !jumpToQuestion) {
                let usersJson = localStorage.getItem("lmsPlayerCurreuntSlides");
                if (usersJson) {
                    usersJson = JSON.parse(usersJson);
                }
                else {
                    usersJson = {};
                }
                if (!usersJson[userId]) {
                    usersJson[userId] = {};
                }
                if (!usersJson[userId][lessonId]) {
                    usersJson[userId][lessonId] = {}
                }

                usersJson[userId][lessonId] = { date: new Date(), slideId: content.id };
                localStorage.setItem("lmsPlayerCurreuntSlides", JSON.stringify(usersJson))
            }
        }
        catch { }
    }

    const handleChangeQuestions = (question) => {
        setNewQuestion(question)
    }

    useEffect(() => {
        if (currentContent) {
            const newContent = {
                ...currentContent.content,
                data: {
                    ...currentContent.content.data,
                    quetions: currentContent.content.data.quetions.map(obj => obj.id === newQuestion.id ? newQuestion : obj)
                }
            }
            changeCurrentContent(newContent, currentContent.index);
            setContentList(contentList => contentList?.map(item => item.id === newContent.id ?  newContent  : item))
            if (shouldAutoChangeContent(newContent.data.quetions)) {
                setTimeout(() => currentContent.index + 1 < contentList?.length && HandleChangeCurrentContent(contentList[currentContent.index + 1], currentContent.index + 1, isOldDesign, true), 3000);
            }
        }
    }, [newQuestion])

    const changeCurrentContent = (content, index, oldDesign = isOldDesign) => {
        const Component = enumCMSContentTypeViewer[content.type];
        setCurrentContent({
            index: index,
            content: content,
            component: <Component
                lessonId={lessonId}
                postAnswer={postAnswer}
                submissions={submissions}
                contentDirPath={contentDirPath}
                scoreByRetries={scoreByRetries}
                data={content.data}
                oldDesign={oldDesign}
                onlyView={onlyView}
                remindSendBtn={remindSendBtn}
                handleChangeQuestions={handleChangeQuestions}
                contentIndex={index}
            />
        });
    }

    return (<div className={`${classes[direction]} ${classes.Player}`} onClick={e => e.stopPropagation()} ref={ref}>
        {close && <div className={classes.Close} onClick={close}>x</div>}

        <div className={classes.PlayerContent}>
            <div className={classes.Responsive} style={{ width: sizes.wrapStyle.width, height: sizes.wrapStyle.height }}>
                <div className={classes.ContentMenu} style={showMenu ? { width: sizes.viewerStyle.menuWidth } : { width: '83px' }}>
                    {<div className={classes.ArrowWrapper} onClick={() => setShowMenu(!showMenu)}>
                        <img className={!showMenu && classes.RotateArrow} src={arrow} />
                    </div>}
                    <div className={classes.ContentMenuScroll}>
                        {contentList && contentList.map((content, i) =>
                            <div title={content.name} className={`${classes.ContentItem} ${currentContent && i === currentContent.index && classes.ContentItemSelected}`} onClick={() => HandleChangeCurrentContent(content, i)} key={i} >
                                <div className={classes.SelectedArrow}></div>
                                <div className={classes.Num}>{i + 1 + '.'} </div>
                                <img src={content.type === 'quetion' ? question : learning} />
                                <div className={classes.Name}>{content.name}</div>
                            </div>)}
                    </div>
                </div>
                <div className={classes.WrapContentViewer}>
                    <div className={classes.ContentViewer} key={currentContent?.index} style={{ height: sizes.viewerStyle.height, width: sizes.viewerStyle.width, zoom: sizes.viewerStyle.zoom }}>
                        <div className={classes.RTLScroll}>
                            {currentContent && currentContent.component}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ zoom: sizes.viewerStyle.zoom > 1 ? 1 : sizes.viewerStyle.zoom }}>
                <Navigator width={sizes.wrapStyle.width} jumpToQuestion={jumpToQuestion} currentContent={currentContent} contentList={contentList} HandleChangeCurrentContent={HandleChangeCurrentContent} currentContentData={currentContentData}/>
            </div>
        </div>
    </div>)
}

export default Player;